<template>
  <v-container fluid fill-height justify-center
      align-center>
      <v-flex xs12 sm10 md7 lg4 xl4>
    <v-card>
      <v-toolbar color="primary">
        <v-toolbar-title class="white--text">Reset password</v-toolbar-title>
      </v-toolbar>
      <div>
      <v-stepper v-model="e1">
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-form v-model="validAcc" ref="form">
              <v-container fluid>
                <v-layout row>
                  <v-flex>
                    <v-text-field
                      name="input-8-1"
                      label="Enter your password"
                      v-model="user.password"
                      min="8"
                      :rules="rules.passwordRules"
                      :append-icon="visibility ? 'visibility' : 'visibility_off'"
                      :append-icon-cb="() => (visibility = !visibility)"
                      :type="visibility ? 'password' : 'text'"
                      counter
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex>
                    <v-text-field
                      name="input-8-1"
                      label="Confirm your password"
                      v-model="user.confirm_password"
                      min="8"
                      :rules="rules.passwordRulesConfirm"
                      :append-icon="visibilityConfirm ? 'visibility' : 'visibility_off'"
                      :append-icon-cb="() => (visibilityConfirm = !visibilityConfirm)"
                      :type="visibilityConfirm ? 'password' : 'text'"
                      counter
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-btn
                  @click.native="saveNewPass"
                  :disabled="!validAcc"
                  color="primary"
                >
                  Save
                </v-btn>
              </v-container>
            </v-form>
          </v-stepper-content>          
          <div row>
            <v-flex xs10 offset-xs1>
              <v-alert
                class="auth"
                :color="alert.type"
                icon="check_circle"
                :value="alert.status"
                transition="scale-transition"
              >
                {{ alert.message }}
              </v-alert>
            </v-flex>
          </div>
        </v-stepper-items>
      <v-footer>
      </v-footer>
      </v-stepper>
    </div>
    </v-card>
  </v-flex>
  </v-container>
</template>

<script>
import axios from "axios";
import VueRecaptcha from "vue-recaptcha";
import {countryCodesSingle} from "../../helpers/countryCodes.js";
export default {
  data() {
    return {
      e1: 1,
      alert: {
        status: false,
        message: null,
        type: null
      },
      validAcc: true,
      rules: {
        passwordRules: [
          v => !!v || "Field is required",
          v => v.length >= 8 || "Password must be at least 8 characters"
        ],
        passwordRulesConfirm: [
          v => !!v || "Field is required",
          v => v == this.user.password || "Password not confirmed"
        ],
      },
      visibility: true,
      visibilityConfirm: true,
      user: {
        password: "",
        confirm_password: ""
      },
    };
  },
  methods: {
    alerting(){
      this.alert.status = !this.alert.status;
      setTimeout(() => {
            this.alert.status = !this.alert.status;
        }, 2500);
    },
    saveNewPass() {
        axios
          .post("/token/reset", { token: this.$route.params.token, new_password: this.user.password })
          .then(response => {
            this.alert.message = 'You have changed your password successfully.'
            this.alert.type = 'success'
            this.alerting()
            setTimeout(() => {
                this.$router.push('/auth/login')
            }, 2000);
          })
          .catch(err => {
            this.alert.message = 'There was an issue with changing your password.'
            this.alert.type = 'error'
            this.alerting()
          });
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/auth/ResetPass.vue